import React from "react"
import './index.scss'
import { getGameType } from "../LinkSelector/_config"
import { getBasePath } from '@/utils/utils';

export default function ImgLinker(props: any) {
  const {imgList, gameIdx, gameList, onImgLoad, onImgError} = props

  const handleUrlJump = () => {
    const type = getGameType(gameIdx, gameList)
    window.open(`${getBasePath()}/intelligence/topCharts/${type}Games/gamesDetails/${gameIdx}`)
  }

  return (
    <>
      {
        imgList.map((item: string, idx: number) => {
          return (
            <img
              crossOrigin="anonymous"
              key={idx}
              src ={item} 
              onClick={() => {if(idx <= 1) handleUrlJump()}} 
              onLoad={() => {
                onImgLoad(idx);
              }}
              onError={() => {
                onImgError(idx);
              }}
              className={`dbi-trending-content dbi-trending-content-${idx}`}
            />
          )
        })
      }
    </>
  )
}